import React from "react";
import CustomDiagramWidget from "@app/widgets/CustomDiagramWidget";
import { Constant } from "@app/const";
import NodeRegistry from "@app/utilities/NodeRegistry";
import Utility from "@app/utilities/Utility";

export class CanvasClient extends React.Component {
  /**
   * Tell app context to update canvas in focus
   */
  updateFocus() {
    window.apm.cache.put(
      Constant.k.NAMESPACE_DIAGRAM_WIDGET,
      "current-view",
      this.props.clientId
    );

    if (this.refs[this.getViewID()]) {
      this.refs[this.getViewID()].updateFocus();
    }  
    document.dispatchEvent(
      new CustomEvent("ev-update-focus", { detail: this.props.clientId })
    );

      
    const isCommonModuleCanvas = this.props.node.props.isCommonModule || Utility.getIsCommonModule(window.apm.serialized);
    if(isCommonModuleCanvas){
      // CM TODO: maybe better to implement in event vs setTimeout
      setTimeout(() => {
        $("#tabs_layout_main_tabs_tab_" + this.props.node.id + " .w2ui-tab").addClass('common-module');
      }, 200)
      
    }
  }

  getViewID() {
    return "graphView-" + this.props.clientId;
  }

  isCircularDepended(module, targetId, visited = [], path = []) {
    visited[module.id] = true;
    path.push(module.name);
    if (module.id === targetId) {
      return true;
    }
    if (module.versions[module.version].flow) {
      const nodes = module.versions[module.version].flow.nodes;
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].type === "module" && !visited[nodes[i].props.parentComponentID] && this.isCircularDepended(window.apm.getNode(nodes[i].props.parentComponentID), targetId, visited, path)) {
          return true;
        }
      }
    }
    path.pop();
    return false;
  }

  /**
   * React render
   * @returns {XML}
   */
  render() {
    this.graphView = (
      <CustomDiagramWidget
        node={this.props.node}
        version={this.props.version}
        clientId={this.props.clientId}
        ref={this.getViewID()}
      />
    );

    return (
      <div className="body">
        <div className="content">
          <div
            className="graph-container"
            onDrop={event => {
              // Drop node on canvas
              const currentViewId = window.apm.cache.get(
                Constant.k.NAMESPACE_DIAGRAM_WIDGET,
                "current-view"
              );
              const diagramWidget = window.apm.cache.get(
                Constant.k.NAMESPACE_DIAGRAM_WIDGET,
                currentViewId
              );
              const node = window.apm.cache.get(
                Constant.k.NAMESPACE_DATATRANSFER,
                "dragndrop"
              );
              
              const currentID = currentViewId.split("_")[0];
              const historyNodes = [];

              var mod = _.filter(window.apm.serialized.components.modules, {
                id: currentID
              });
              
              if (node._class === "BeginNodeModel") {
                return;
              }
              // CM TODO: do not allow drag onto a Common Module
              if(diagramWidget.getDataModel().props.isCommonModule){
                return;
              }
              if (node.type === "module") {
                
                if (node.id === currentID) {
                  window.apm.notification.post(
                      "error",
                      window.l.notification.module_cannot_be_added_to_their_own_flow
                  );
                  return;
                }
                const circularDependencies = [];
                // TODO: common modules and circular dependencies
                const skipCircularDependencies = !mod[0].props.isCommonModule;
                if(!skipCircularDependencies){
                  if (this.isCircularDepended(node, currentID, [], circularDependencies)) {
                    window.apm.notification.post(
                        "error",
                        "Module cannot be added due to circular dependencies between " + circularDependencies.join(", ")
                    );
                    return;
                  }
                }
                
              }

              if (node !== null && node.type !== "variable") {
                window.apm.cache.remove(
                    Constant.k.NAMESPACE_DATATRANSFER,
                    "dragndrop"
                );

                const points = this.refs[
                    this.getViewID()
                    ].getClosestGridPoint(event);
                const className = node._class;

                window.apm.printDebug(
                    "onDrop",
                    points,
                    Constant.k.DEBUG_TREE
                );
                window.apm.printDebug(
                    "node type",
                    className,
                    Constant.k.DEBUG_TREE
                );

                const newName = node.name;
                const nodeProps = _.cloneDeep(node.props);
                const newNode = new NodeRegistry.r[className](
                    newName,
                    points.x,
                    points.y,
                    nodeProps
                );
                
                if (node.type === "module") {
                  var lastVersion = 0;
                  for (var property in node.versions) {
                    if (node.versions.hasOwnProperty(property)) {
                      lastVersion = property;
                    }
                  }
                  newNode.props.ref = node.id;
                }
                newNode.props.parentComponentID = node.id;

                if(node.type === 'module'){
                  // DEVDES2-1046: Disabled modules cannot be dragged and dropped onto canvas
                  const isCurrentViewModuleDisabledInFlow = window.apm.serialized.components.modules.find(mod => mod.id === currentID).props.config.disabledInFlow;
                  if(isCurrentViewModuleDisabledInFlow && node.props.config.disabledInFlow){
                    newNode.props.config = Object.assign({}, node.props.config);
                    newNode.props.config.disabledInFlow = false;
                  }
                  
                  // create inpts for config
                  newNode.props.config.inputs = window.apm.getModuleInputs(node);
                }
                newNode.props.timeAddedToFlow = window.apm.timestamp;

                // CM TODO: module versions and flowVersion: isDrop tells addNode to register common modules instances with a flowVersion number
                this.refs[this.getViewID()].getFlowModel().addNode(newNode, {isDrop: true, graphModel: diagramWidget.getDataModel()});
                this.refs[this.getViewID()].forceUpdate();
                window.apm.postEventToCurrentView({
                  target: "request-update-member"
                });

                window.apm.postEventToCurrentView({
                  target: "request-component-panel",
                  event: node,
                  shouldFocusInput: true
                });

                // CM TODO: is this redundant? already handled by BaseDiagram method?
                const version = this.props.version || 1; // diagramWidget.getDataModel().version || 1;
                diagramWidget.saveDatabase(version);
                window.apm.reactDOMComponents.render({ name: 'SettingWidget', props: { serialized: window.apm.serialized }, $el: $('#settings') });
                
                //Save canvas history changes
                historyNodes.push(newNode);
                
                diagramWidget.history.saveChanges("onDropTwo", {nodes: historyNodes});
              }
            }}
            onDragOver={event => {
              event.preventDefault();
            }}
          >
            {this.graphView}
          </div>
        </div>
      </div>
    );
  }
}
